import { Product } from "../models/Product";

export const products: Record<string, Product> = {
  child_support_tracker: {
    id: "price_1RMaLCGaV74rHEMxALj4k4Qm",
    title: "Child Support Tracker",
    description: "Track payments, modify orders, document disputes.",
    price: 79,
    type: "feature",
    unlocks: ["child_support_tracker"],
    upsellProducts: ["family_essentials_bundle", "all_features_bundle"],
  },
  spousal_support_tracker: {
    id: "price_1RMaLTGaV74rHEMxNgjsKjYf",
    title: "Spousal Support Tracker",
    description: "Track payments, modify orders, document disputes.",
    price: 79,
    type: "feature",
    unlocks: ["spousal_support_tracker"],
    upsellProducts: ["family_essentials_bundle", "all_features_bundle"],
  },
  discovery_manager: {
    id: "price_1RMaLhGaV74rHEMxrka67gGI",
    title: "Discovery Manager",
    description: "Upload discovery requests, track tasks and deadlines.",
    price: 149,
    type: "feature",
    unlocks: ["discovery_manager"],
    upsellProducts: ["litigation_bundle", "all_features_bundle"],
  },
  filing_breakdown: {
    id: "price_1RMaMFGaV74rHEMxB0aBshjH",
    title: "Filing Breakdown",
    description:
      "Upload legal filings, break into sections, collaborate on responses.",
    price: 129,
    type: "feature",
    unlocks: ["filing_breakdown"],
    upsellProducts: ["litigation_bundle", "all_features_bundle"],
  },
  financial_disclosures: {
    id: "price_1RMaMnGaV74rHEMx83wXFSR5",
    title: "Financial Disclosures",
    description: "Organize and report income, assets, and debts accurately.",
    price: 149,
    type: "feature",
    unlocks: ["financial_disclosures"],
    upsellProducts: ["family_essentials_bundle", "all_features_bundle"],
  },
  holiday_schedule_tracker: {
    id: "",
    title: "Holiday Schedule Tracker",
    description:
      "Stay organized and on top of your holiday schedule with ease.",
    price: 49,
    type: "feature",
    unlocks: ["holiday_schedule_tracker"],
    upsellProducts: ["family_essentials_bundle", "all_features_bundle"],
  },
  visitation_schedule_tracker: {
    id: "",
    title: "Visitation Schedule Tracker",
    description: "Manage and track visitation schedules effortlessly.",
    price: 49,
    type: "feature",
    unlocks: ["visitation_schedule_tracker"],
    upsellProducts: ["family_essentials_bundle", "all_features_bundle"],
  },
  family_essentials_bundle: {
    id: "price_1RMaTiGaV74rHEMx79PHVMZC",
    title: "Family Essentials Bundle",
    description: "Child Support + Spousal Support + Financial Disclosures.",
    price: 199,
    type: "bundle",
    unlocks: [
      "child_support_tracker",
      "spousal_support_tracker",
      "financial_disclosures",
      "holiday_schedule_tracker",
      "visitation_schedule_tracker",
    ],
    upsellProducts: ["all_features_bundle"],
  },
  litigation_bundle: {
    id: "price_1RMaW7GaV74rHEMxGZTeL6s9",
    title: "Litigation Bundle",
    description: "Discovery Manager + Filing Breakdown.",
    price: 199,
    type: "bundle",
    unlocks: ["discovery_manager", "filing_breakdown"],
    upsellProducts: ["all_features_bundle"],
  },
  all_features_bundle: {
    id: "price_1RMaWVGaV74rHEMx5ScXvXKm",
    title: "All Features Bundle",
    description: "Unlock every feature for maximum case management power.",
    price: 299,
    type: "bundle",
    unlocks: [
      "spousal_support_tracker",
      "spousal_support_tracker",
      "discovery_manager",
      "filing_breakdown",
      "financial_disclosures",
    ],
    upsellProducts: [], // No upsell past this
  },
};

export type ProductType = keyof typeof products;
